import request from "~/utils/request";

class MyUploadAdapter {
  constructor(props) {
    // CKEditor 5's FileLoader instance.
    this.loader = props;
    // URL where to send files.
  }

  // Starts the upload process.
  upload() {
    return this.loader.file.then((uploadFile) => {
      return new Promise((resolve, reject) => {
        const data = new FormData();

        data.append("url", uploadFile);

        request.post("/v1/upload/", data).then((response) => {
          this.loader.uploaded = true;
          resolve({
            default: response.data.data.url,
          });
        });
      });
    });
  }
}

export default MyUploadAdapter;
